import React, { useState } from 'react';
import { Menu, X, LogIn, Ticket, ShoppingBag } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import { trackEvent } from '../lib/analytics';

const EVENTBRITE_URL = 'https://www.eventbrite.com/o/royal-bar-grill-120928056108';
const ORDER_URL = 'https://royalbargrill.com';
const orderNowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 16px',
  background: 'var(--brand-gold)',
  color: '#000000',
  fontWeight: 600,
};

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    // If not on homepage, navigate to homepage first
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  const goToReservations = () => {
    trackEvent('reserve_seat_click', { link_location: 'header' });
    window.open(EVENTBRITE_URL, '_blank', 'noopener,noreferrer');
    setMobileMenuOpen(false);
  };

  const goToTeamLogin = () => {
    navigate('/team');
    setMobileMenuOpen(false);
  };

  const openEventbrite = () => {
    trackEvent('eventbrite_click', { link_location: 'header' });
    window.open(EVENTBRITE_URL, '_blank', 'noopener,noreferrer');
    setMobileMenuOpen(false);
  };

  const openOrderNow = (loc) => {
    trackEvent('order_now_click', { link_location: loc });
    window.open(ORDER_URL, '_blank', 'noopener,noreferrer');
    setMobileMenuOpen(false);
  };

  const goHome = () => {
    navigate('/');
    window.scrollTo(0, 0);
  };

  return (
    <header className="dark-header">
      <div className="header-content">
        <img 
          src="https://customer-assets.emergentagent.com/job_elegant-royal-bar/artifacts/6ywx5xvf_CFB2E630-E067-4D50-B2DB-A530D292F3D8.png" 
          alt="Royal Bar & Grill" 
          className="dark-logo"
          onClick={goHome}
          data-testid="header-logo"
        />
        
        <nav className="dark-nav desktop-nav">
          <button onClick={() => scrollToSection('menu')} className="dark-nav-link">Menu</button>
          <button onClick={() => scrollToSection('gallery')} className="dark-nav-link">Gallery</button>
          <button onClick={() => scrollToSection('events')} className="dark-nav-link">Events</button>
          <button onClick={goToReservations} className="dark-nav-link" data-testid="reserve-seat-nav">Reserve a Seat</button>
          <button onClick={() => openOrderNow('header')} className="dark-nav-link order-now-btn" style={orderNowStyle} data-testid="order-now-nav">
            <ShoppingBag size={18} />
            Order Now
          </button>
          <button onClick={openEventbrite} className="dark-nav-link eventbrite-btn" data-testid="eventbrite-nav-btn">
            <Ticket size={18} />
            Upcoming Events
          </button>
          <button onClick={() => scrollToSection('contact')} className="dark-nav-link">Contact</button>
          <button onClick={goToTeamLogin} className="dark-nav-link team-login-btn">
            <LogIn size={18} />
            Team Login
          </button>
        </nav>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {mobileMenuOpen && (
        <nav className="mobile-nav">
          <button onClick={() => scrollToSection('menu')} className="dark-nav-link">Menu</button>
          <button onClick={() => scrollToSection('gallery')} className="dark-nav-link">Gallery</button>
          <button onClick={() => scrollToSection('events')} className="dark-nav-link">Events</button>
          <button onClick={goToReservations} className="dark-nav-link">Reservations</button>
          <button onClick={() => openOrderNow('mobile_menu')} className="dark-nav-link order-now-btn" style={orderNowStyle} data-testid="order-now-mobile">
            <ShoppingBag size={18} />
            Order Now
          </button>
          <button onClick={openEventbrite} className="dark-nav-link eventbrite-btn" data-testid="eventbrite-nav-mobile">
            <Ticket size={18} />
            Upcoming Events
          </button>
          <button onClick={() => scrollToSection('contact')} className="dark-nav-link">Contact</button>
          <button onClick={goToTeamLogin} className="dark-nav-link team-login-btn">
            <LogIn size={18} />
            Team Login
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;Header;